import type { ImgHTMLAttributes } from 'react'

import { cn } from 'lib/utils'

import { imageMap } from '../Image/imageMap'
import type { ImageName } from '../Image/imageMap'

import '../Image/index.scss'

const mainClass = 'image'

interface PictureSource {
  name: ImageName
  media: string
}

interface PictureProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  sources: PictureSource[]
  fallback: ImageName
  alt?: string
  loading?: 'lazy' | 'eager'
  fetchPriority?: 'high' | 'low' | 'auto'
  decoding?: 'async' | 'auto' | 'sync'
}

export const Picture = ({
  sources,
  fallback,
  className = '',
  width,
  height,
  alt = '',
  loading = 'lazy',
  fetchPriority,
  decoding = 'async',
  sizes,
  ...restProps
}: PictureProps) => {
  const fallbackSrc = imageMap[fallback]

  return (
    <picture>
      {sources.map((source) => (
        <source
          key={source.name}
          srcSet={imageMap[source.name]}
          media={source.media}
          type="image/webp"
        />
      ))}
      <img
        className={cn(mainClass, className)}
        src={fallbackSrc}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding={decoding}
        fetchPriority={fetchPriority}
        sizes={sizes}
        {...restProps}
      />
    </picture>
  )
}
